import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

const GA_ID = "G-PGZC0BQ5T8";

/**
 * Sends a GA4 page_view event on every client-side route change.
 * Required because gtag in index.html only fires on initial load.
 */
export default function GAPageTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const page_path = pathname + search;
    window.gtag("config", GA_ID, {
      page_path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search]);

  return null;
}